module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<div class=\"route\"><%= model.route || 'http://ibt.torux.at/de/unternehmen' %></div>\n<div class=\"menu\">\n<%\nfor(var routeIndex in model.navigationElements){\n%><a href=\"<%- model.navigationElements[routeIndex].route %>\" title=\"<%= model.navigationElements[routeIndex].title %>\"><%= model.navigationElements[routeIndex].title %></a><%\n}\n%>\n</div>\n</div>"
  , __filename = "components/templates/topNavBar/topNavBar.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<div class=\"route\">")
    ; __line = 2
    ; __append(escapeFn( model.route || 'http://ibt.torux.at/de/unternehmen' 
))
    ; __append("</div>\n<div class=\"menu\">\n")
    ; __line = 4
    ; 
for(var routeIndex in model.navigationElements){

    ; __line = 6
    ; __append("<a href=\"")
    ; __append( model.navigationElements[routeIndex].route )
    ; __append("\" title=\"")
    ; __append(escapeFn( model.navigationElements[routeIndex].title ))
    ; __append("\">")
    ; __append(escapeFn( model.navigationElements[routeIndex].title ))
    ; __append("</a>")
    ; 
}

    ; __line = 8
    ; __append("\n</div>\n</div>")
    ; __line = 10
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/topNavBar/topNavBar.ejs

}